const ICON_COLORS = {
  "uil uil-calendar-alt": { color: "#038edc", bg: "rgba(3,142,220,0.10)" },
  "uil uil-history":      { color: "#51d28c", bg: "rgba(81,210,140,0.10)" },
  "uil uil-edit":         { color: "#f1734f", bg: "rgba(241,115,79,0.10)" },
  "uil uil-user-plus":    { color: "#038edc", bg: "rgba(3,142,220,0.10)" },
  "uil uil-envelope":     { color: "#564ab1", bg: "rgba(86,74,177,0.10)" },
  "uil uil-list-ul":      { color: "#9299a8", bg: "rgba(146,153,168,0.10)" },
};

const ListElement = ({ title, data, icon = "uil uil-list-ul", onClick }) => {
  const { color, bg } = ICON_COLORS[icon] ?? { color: "#9299a8", bg: "rgba(146,153,168,0.10)" };

  return (
    <div
      onClick={onClick}
      style={{
        display: "flex", alignItems: "center", gap: 14,
        padding: "12px 0", borderBottom: "1px solid #f3f4f6",
        cursor: onClick ? "pointer" : "default",
        transition: onClick ? "background 0.15s" : undefined,
        borderRadius: onClick ? 8 : undefined,
        margin: onClick ? "0 -8px" : undefined,
        padding: onClick ? "12px 8px" : "12px 0",
      }}
      onMouseEnter={onClick ? (e) => { e.currentTarget.style.background = "rgba(3,142,220,0.04)"; } : undefined}
      onMouseLeave={onClick ? (e) => { e.currentTarget.style.background = "transparent"; } : undefined}
    >
      <div style={{ width: 38, height: 38, borderRadius: 10, background: bg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
        <i className={icon} style={{ fontSize: 17, color }} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ margin: 0, fontSize: 11, fontWeight: 600, color: "#9299a8", textTransform: "uppercase", letterSpacing: "0.05em" }}>{title}</p>
        <p style={{ margin: 0, fontSize: 14, fontWeight: 400, color: "#1a2236", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {data ?? "—"}
        </p>
      </div>
    </div>
  );
};

export default ListElement;
